import React from 'react';
import Button from "../../../components/ui/button/button";

import {ReactComponent as PlusIcon} from "../../../images/icons/ui/plus-icon.svg";
import {ReactComponent as EditIcon} from "../../../images/icons/ui/edit-icon.svg";
import {ReactComponent as OrderUpIcon} from "../../../images/icons/ui/order-up.svg";
import {ReactComponent as OrderDownIcon} from "../../../images/icons/ui/order-down.svg";
import {ReactComponent as TrashIcon} from "../../../images/icons/ui/trash-icon.svg";
import API from "../../../components/api";
import ModalComponent from "../../../components/ui/modalComponent/modalComponent";
import TextField from "../../../components/TextField/TextField";
import {withRouter} from "../../../layouts/AdminLayout/AdminLayout";


class AdminPanelServicesPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: [],

            currentCategory: {},

            isCategoryCreateOpen: false,
            isCategoryEditOpen: false,
            isCategoryDeleteOpen: false,

            categoryNameCreated: '',
            categoryNameEdited: '',
        }

        this.swapCategory = (categoryId, side) => {
            const {categories} = this.state;

            const index = categories.findIndex(c => c.id === categoryId);
            if (index === -1) return;

            const targetIndex =
                side === 'up'
                    ? index - 1
                    : side === 'down'
                        ? index + 1
                        : index;

            if (targetIndex < 0 || targetIndex >= categories.length) {
                return;
            }

            const current = categories[index];
            const target = categories[targetIndex];

            if (current.order == null || target.order == null) {
                return;
            }

            categories[index] = target;
            categories[targetIndex] = current;

            this.setState({categories: categories})
        }

        this.updateCategories = () => {
            API.adminGetCategories()
                .then(data => this.setState({categories: data}))
                .catch(error => {
                })
        }

        this.addCategory = (name) => {
            API.adminCreateCategory(name)
                .then(data => {
                    this.props.addSnackbar("Категория успешно создана", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateCategories()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось добавить категорию", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.editCategory = (categoryId, name) => {
            API.adminEditCategory(categoryId, name)
                .then(data => {
                    this.props.addSnackbar("Категория успешно изменена", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateCategories()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось изменить категорию", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.deleteCategory = (categoryId) => {
            API.adminDeleteCategory(categoryId)
                .then(data => {
                    this.props.addSnackbar("Категория успешно удалена", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateCategories()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось удалить категорию", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.saveCategories = (categories) => {
            let newOrders = []

            categories.forEach((category, index) => {
                newOrders.push(category.id)
            })

            API.adminSaveCategoriesOrder(newOrders)
                .then(data => {
                    this.props.addSnackbar("Порядок категорий сохранен", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateCategories()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось сохранить", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }
    }

    componentDidMount() {
        this.updateCategories()
    }

    render() {
        return <div className='admin-page-container'>
            <div className='header'>
                <div className='title'>
                    Услуги
                </div>
                <div className='controls'>
                    <Button type='accent' size='medium' onClick={() => {
                        this.saveCategories(this.state.categories)
                    }}>
                        Сохранить изменения
                    </Button>
                    <Button type='primary' size='medium'
                            onClick={() => this.updateCategories()}>
                        Отменить
                    </Button>
                </div>
            </div>
            <div className='content'>
                <div className='title'>
                    Категории
                </div>
                <Button type='secondary' size='large' fullWidth
                        startIcon={<PlusIcon/>}
                        onClick={() => this.setState({isCategoryCreateOpen: true,})}>
                    Добавить категорию
                </Button>
                <div className='categories'>
                    {
                        this.state.categories.map((category, index) => {
                            return <div key={category.id} className='category'
                                        onClick={(e) => {
                                            if (e.target !== e.currentTarget) return;
                                            this.props.navigate(`/admin/panel/services/${category.id}/`);
                                        }}>
                                <div className='left'>
                                    <div className='title'
                                         onClick={() => this.props.navigate(`/admin/panel/services/${category.id}/`)}>
                                        {category.name}
                                    </div>
                                    <Button customClass='icon-size-24' type='secondary' size='medium'
                                            onClick={() => {
                                                this.props.navigate(`/admin/panel/services/${category.id}/`);
                                            }}>
                                        Перейти
                                    </Button>
                                </div>
                                <div className='icon-buttons'>
                                    <div className='divider'/>
                                    <Button type='primary' size='medium' fullWidth
                                            startIcon={<EditIcon/>}
                                            onClick={() => this.setState({
                                                isCategoryEditOpen: true,
                                                currentCategory: category,
                                                categoryNameEdited: category.name
                                            })}/>
                                    <div className='divider'/>
                                    <Button customClass='icon-size-24' type='secondary' size='medium' fullWidth
                                            startIcon={<OrderUpIcon/>}
                                            onClick={() => this.swapCategory(category.id, 'up')}/>
                                    <Button customClass='icon-size-24' type='secondary' size='medium' fullWidth
                                            startIcon={<OrderDownIcon/>}
                                            onClick={() => this.swapCategory(category.id, 'down')}/>
                                    <div className='divider'/>
                                    <Button type='primary' size='medium' fullWidth
                                            startIcon={<TrashIcon/>}
                                            onClick={() => this.setState({
                                                isCategoryDeleteOpen: true,
                                                currentCategory: category
                                            })}/>

                                </div>
                            </div>
                        })
                    }
                </div>
                <ModalComponent customClass="admin-panel-modal"
                                isOpen={this.state.isCategoryCreateOpen}
                                onClose={() => this.setState({isCategoryCreateOpen: false})}>
                    <div className='admin-panel-modal-entry'>
                        <div className='title'>
                            Новая категория
                        </div>
                        <TextField label='Название' fullWidth value={this.state.categoryNameCreated}
                                   onChange={(e) => this.setState({categoryNameCreated: e.target.value})}/>
                        <div className='buttons row'>
                            <Button type='accent' size='large' fullWidth onClick={() => {
                                this.addCategory(this.state.categoryNameCreated)
                                this.setState({isCategoryCreateOpen: false, categoryNameCreated: ''})
                            }}>
                                Добавить
                            </Button>
                            <Button type='primary' size='large' fullWidth
                                    onClick={() => this.setState({isCategoryCreateOpen: false})}>
                                Отменить
                            </Button>
                        </div>
                    </div>
                </ModalComponent>
                <ModalComponent customClass="admin-panel-modal"
                                isOpen={this.state.isCategoryEditOpen}
                                onClose={() => this.setState({isCategoryEditOpen: false})}>
                    <div className='admin-panel-modal-entry'>
                        <div className='title'>
                            Редактирование
                        </div>
                        <TextField label='Название' fullWidth value={this.state.categoryNameEdited}
                                   onChange={(e) => this.setState({categoryNameEdited: e.target.value})}/>
                        <div className='buttons row'>
                            <Button type='accent' size='large' fullWidth onClick={() => {
                                this.editCategory(this.state.currentCategory.id, this.state.categoryNameEdited)
                                this.setState({isCategoryEditOpen: false, categoryNameEdited: ''})
                            }}>
                                Сохранить
                            </Button>
                            <Button type='primary' size='large' fullWidth
                                    onClick={() => this.setState({isCategoryEditOpen: false})}>
                                Отменить
                            </Button>
                        </div>
                    </div>
                </ModalComponent>
                <ModalComponent customClass="admin-panel-modal"
                                isOpen={this.state.isCategoryDeleteOpen}
                                onClose={() => this.setState({isCategoryDeleteOpen: false})}>
                    <div className='admin-panel-modal-entry'>
                        <div className='title'>
                            Вы действительно хотите удалить эту категорию?
                        </div>
                        <div className='warning'>
                            Всё, что находится внутри неё, тоже будет удалено!
                        </div>
                        <div className='description'>
                            Оказание разовой неотложной помощи при периодонтите (раскрытие полости зуба, ревизия
                            корневого канала, медикаментозная обработка корневого канала)
                        </div>
                        <div className='buttons row'>
                            <Button type='outlined' size='large' fullWidth onClick={() => {
                                this.deleteCategory(this.state.currentCategory.id)
                                this.setState({isCategoryDeleteOpen: false})
                            }}>
                                Да, удалить
                            </Button>
                            <Button type='primary' size='large' fullWidth
                                    onClick={() => this.setState({isCategoryDeleteOpen: false})}>
                                Отменить
                            </Button>
                        </div>
                    </div>
                </ModalComponent>
            </div>
        </div>
    }
}


export default withRouter(AdminPanelServicesPage);
